import { features } from '@/mocks/features';

export default function FeatureGrid() {
  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            Everything You Need in One Place
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            From finding spreadsheets to shipping your haul, we cover every step of your CSSBuy journey.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 transition-all duration-200 overflow-hidden"
            >
              <div className="relative w-full h-40 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  title={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-200 transition-colors flex-shrink-0">
                    <i className={`${feature.icon} text-lg`}></i>
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-base">
                    {feature.title}
                  </h3>
                </div>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}